import React, { ReactElement, ReactNode, CSSProperties } from 'react';
import classNames from 'classnames';
import Item from './Item';
import InputItem from './InputItem';
import TextareaItem from './TextareaItem';
import CheckboxItem from './CheckboxItem';
import RadioGroupItems from './RadioGroupItems';
import styles from './index.module.scss';

interface Props {
  border?: boolean;
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
}

function List(props: Props): ReactElement {
  const { className, children, border = false, style } = props;

  const cls = classNames(styles.listClass, className, {
    [styles.listBorder]: border,
  });

  return (
    <div className={cls} style={style}>
      {children}
    </div>
  );
}

List.Item = Item;
List.InputItem = InputItem;
List.TextareaItem = TextareaItem;
List.CheckboxItem = CheckboxItem;
List.RadioGroupItems = RadioGroupItems;

export default List;
